import React from 'react'

export default ({
  className = ''
}) => (
<svg className={className} xmlns="http://www.w3.org/2000/svg" width="16.25" height="11.25" viewBox="0 0 16.25 11.25">
  <path d="M1.875-12.5V-1.25h16.25V-12.5Zm2.7,1.25H15.43L10-7.637ZM3.125-10.7,9.648-6.348,10-6.133l.352-.215L16.875-10.7v8.2H3.125Z" transform="translate(-1.875 12.5)"/>
</svg>
  )
